import type { ReactNode } from 'react'
import { useTelegramSafeArea } from '../../hooks/useTelegramSafeArea'
import { useMobileFormViewport } from '../../hooks/useMobileFormViewport'

/**
 * Combines Telegram insets with browser safe areas (including iOS PWA) on the document root.
 * Renders children only (no extra DOM).
 */
export function TelegramSafeAreaProvider({ children }: { children: ReactNode }) {
  useTelegramSafeArea()
  useMobileFormViewport()
  return <>{children}</>
}
